import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Pagination from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

function ListISEEUploaded(props) {
  const apiToken = useContext(TokenContext);
  const [ISEEList, setISEEList] = useState();
  const [ISEEListTemp, setISEEListTemp] = useState();
  const [loading, setLoading] = useState(true);
  const [isOpen, toggleModal] = useState(false);
  const [ISEEId, setISEEId] = useState();
  const [isUpdating, setIsUpdating] = useState(false);
  const [isPolling, setIsPolling] = useState(false);

  useEffect(() => {
    setLoading(true);

    loadIsee();
  }, []);

  const [filters, setFilters] = useState({
    name: "",
    fiscalCode: "",
    date: "",
    city: "",
    bando: "",
    state: "",
  });

  const bandoOptions = [
    ...new Set(
      (ISEEListTemp ?? [])
        .flatMap((x) => (x.bando ?? "").split(",").map((n) => n.trim()))
        .filter(Boolean),
    ),
  ].sort((a, b) => a.localeCompare(b, "it"));

  const truncateBando = (name) => {
    if (!name) return "N/A";
    return name.length > 50 ? `${name.substring(0, 50)}..` : name;
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const filteredItems = (ISEEListTemp ?? []).filter((x) => {
    const fullName = `${x.user?.firstName ?? ""} ${x.user?.lastName ?? ""}`
      .trim()
      .toLowerCase();

    return (
      (filters.name === "" || fullName.includes(filters.name.toLowerCase())) &&
      (filters.fiscalCode === "" ||
        (x.user?.fiscalCode ?? "")
          .toLowerCase()
          .includes(filters.fiscalCode.toLowerCase())) &&
      (filters.city === "" ||
        (x.user?.city ?? "")
          .toLowerCase()
          .includes(filters.city.toLowerCase())) &&
      (filters.date === "" || (x.date ?? "").includes(filters.date)) &&
      (filters.bando === "" ||
        (x.bando ?? "")
          .split(",")
          .map((n) => n.trim())
          .includes(filters.bando)) &&
      (filters.state === "" || x.state === filters.state)
    );
  });

  const loadIsee = async () => {
    try {
      const response = await Repo.getIseeListUploaded(apiToken);

      setISEEListTemp(response.data);

      const hasLoaded = response.data.some(
        (x) => x.state === "CREATED" || x.state === "RUNNING",
      );

      if (!hasLoaded) {
        setIsPolling(false);
        setIsUpdating(false);
      }
    } catch (error) {
      console.log(error);
      setIsPolling(false);
      setIsUpdating(false);
    } finally {
      setLoading(false);
    }
  };
  const startIseeValidation = async () => {
    setIsUpdating(true);

    const payload = {
      announcementId: null,
      tipo: 4,
    };

    Repo.startAggiornamento(apiToken, payload)
      .then((response) => {
        toggleModal(false);
        setIsPolling(true);
      })
      .catch((error) => {
        console.log(error);

        alert(
          error?.response?.data || "Errore durante l'avvio dell'aggiornamento",
        );
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

  const stateLabels = {
    LOADED: "Caricato",
    VALIDATED: "Validato",
    REFUSED: "Rifiutato",
    ERROR: "Errore",
  };

  useEffect(() => {
    if (!isPolling) return;

    let timeout;

    const poll = async () => {
      await loadIsee();

      timeout = setTimeout(poll, 3000);
    };

    poll();

    return () => clearTimeout(timeout);
  }, [isPolling]);

  return (
    <>
      <div>
        <h1>Verifica ISEE</h1>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <p className="mb-0">
            Tutti gli ISEE da validare e in errore ({ISEEListTemp?.length ?? 0})
          </p>

          <div className="d-flex gap-2">
            <button
              className="btn btn-primary"
              onClick={() => toggleModal(true)}
              disabled={isUpdating || isPolling}
            >
              Avvia verifica automatica
            </button>

            <Link to="/lista_isee/logs">
              <button className="btn btn-outline-primary ml-2">
                Storico verifiche
              </button>
            </Link>
          </div>
        </div>
        <div className="d-flex pb-2 mb-2">
          <div className="col-3">
            <input
              className="form-control"
              placeholder="Nome e cognome"
              name="name"
              value={filters.name}
              onChange={handleFilterChange}
            />
          </div>

          <div className="col-2">
            <input
              className="form-control"
              placeholder="Codice fiscale"
              name="fiscalCode"
              value={filters.fiscalCode}
              onChange={handleFilterChange}
            />
          </div>

          <div className="col-2">
            <input
              className="form-control"
              placeholder="Città"
              name="city"
              value={filters.city}
              onChange={handleFilterChange}
            />
          </div>

          <div className="col-3">
            <select
              className="form-control"
              name="bando"
              value={filters.bando}
              onChange={handleFilterChange}
            >
              <option value="">Tutti i bandi</option>
              {bandoOptions.map((name) => (
                <option key={name} value={name} title={name}>
                  {truncateBando(name)}
                </option>
              ))}
            </select>
          </div>

          <div className="col-2">
            <select
              className="form-control"
              name="state"
              value={filters.state}
              onChange={handleFilterChange}
            >
              <option value="">Tutti</option>

              {Object.entries(stateLabels).map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="container">
          {ISEEList && ISEEList.length > 0 ? (
            <>
              {/* Intestazione */}

              <div className="d-flex fw-bold border-bottom pb-2 mb-2">
                <div className="col-3">
                  <strong>Dati cittadino</strong>
                </div>
                <div className="col-2">
                  <strong>Codice Fiscale</strong>
                </div>
                <div className="col-2">
                  <strong>Città</strong>
                </div>
                <div className="col-3">
                  <strong>Bando</strong>
                </div>
                <div className="col-1">
                  <strong>Stato</strong>
                </div>
                <div className="col-1 text-right"></div>
              </div>

              {/* Lista */}
              {ISEEList.map((x, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center py-2 border-bottom"
                >
                  <div className="col-3">
                    {x.user?.firstName || "N/A"} {x.user?.lastName || "N/A"}
                  </div>
                  <div className="col-2">{x.user?.fiscalCode ?? "N/A"}</div>
                  <div className="col-2">{x.user?.city && x.user.city.toUpperCase()}</div>
                  <div className="col-3">
                    <span title={x.bando || undefined}>
                      {truncateBando(x.bando)}
                    </span>
                  </div>
                  <div className="col-1">
                    <span
                      className={`badge ${
                        x.state === "VALIDATED"
                          ? "badge-success"
                          : x.state === "ERROR"
                            ? "badge-danger"
                            : x.state === "REFUSED"
                              ? "badge-warning"
                              : "badge-secondary"
                      }`}
                    >
                      {stateLabels[x.state] ?? x.state}
                    </span>
                  </div>
                  <div className="col-1 text-right">
                    <Link to={`/lista_isee/verifica_isee?idIsee=${x.id}`}>
                      <button
                        className="btn btn-outline-primary p-2"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Dettaglio"
                      >
                        <svg className="icon icon-primary mr-1">
                          <use href={`${iconSprite}#it-search`} />
                        </svg>
                      </button>
                    </Link>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="text-center py-3">
              <b>Non ci sono ISEE da verificare.</b>
            </div>
          )}

          <Pagination
            items={filteredItems}
            setCurrentItems={setISEEList}
            itemsPerPage={50}
          />
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Aggiornamento automatico ISEE"
        body="Confermi di voler avviare la validazione automatica degli ISEE caricati?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => startIseeValidation()}
      />
      {loading && <Loader />}
    </>
  );
}

export default ListISEEUploaded;
